import React from 'react'
import Text, { TextProps } from '../Base'

export type Props = Omit<TextProps, 'tag' | 'weight'>

const Strong: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <Text tag="strong" weight="bold" {...rest}>
      {children}
    </Text>
  )
}

export default Strong
